import { useCallback, useEffect, useState } from 'react';
import { BalancePaymentMethodsApiResponse } from 'src/types/Balance';
import { fetchBalancePaymentMethods as fetchBalancePaymentMethodsFromApi } from 'src/components/selfService/common/Balance/api/fetchBalancePaymentMethods';

export type UseFetchBalancePaymentMethodsReturnType = {
  isLoading: boolean;
  hasError: boolean;
  balancePaymentMethods: BalancePaymentMethodsApiResponse | null;
  fetchBalancePaymentMethods: () => Promise<void>;
};

export const useFetchBalancePaymentMethods = (
  externalBalanceBuyerId: string | null
): UseFetchBalancePaymentMethodsReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [balancePaymentMethods, setBalancePaymentMethods] =
    useState<BalancePaymentMethodsApiResponse | null>(null);

  const fetchBalancePaymentMethods = useCallback(async (): Promise<void> => {
    if (!externalBalanceBuyerId) {
      return;
    }

    try {
      setIsLoading(true);
      setHasError(false);

      const response = await fetchBalancePaymentMethodsFromApi(
        externalBalanceBuyerId
      );
      setBalancePaymentMethods(response);
    } catch (error) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [externalBalanceBuyerId]);

  useEffect(() => {
    fetchBalancePaymentMethods();
  }, [externalBalanceBuyerId, fetchBalancePaymentMethods]);

  return {
    isLoading,
    hasError,
    balancePaymentMethods,
    fetchBalancePaymentMethods,
  };
};
